'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _playlists = require('redux/modules/playlists');

var playlistsActions = _interopRequireWildcard(_playlists);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _ClearableInput = require('components/ClearableInput/ClearableInput');

var _ClearableInput2 = _interopRequireDefault(_ClearableInput);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./PlaylistsSearchBar.scss');

var PlaylistsSearchBar = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    kw: state.playlists.kw
  };
}, (0, _extends3.default)({}, playlistsActions)), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(PlaylistsSearchBar, _Component);

  function PlaylistsSearchBar() {
    var _ref;

    (0, _classCallCheck3.default)(this, PlaylistsSearchBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = PlaylistsSearchBar.__proto__ || (0, _getPrototypeOf2.default)(PlaylistsSearchBar)).call.apply(_ref, [this].concat(args)));

    _this.state = { kw: _this.props.kw };
    return _this;
  }

  (0, _createClass3.default)(PlaylistsSearchBar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.kw !== this.props.kw) {
        this.setState({ kw: nextProps.kw });
      }
    }
  }, {
    key: 'filter',
    value: function filter(kw) {
      this.setState({ kw: kw });
      this.props.filter(kw);
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.context.t;
      var kw = this.state.kw;


      return _react2.default.createElement(
        'div',
        { className: styles.searchBar },
        _react2.default.createElement(_ClearableInput2.default, {
          delay: 300,
          onChange: this.filter,
          kw: kw,
          title: t('Search')
        })
      );
    }
  }]);
  return PlaylistsSearchBar;
}(_react.Component), _class3.propTypes = {
  filter: _propTypes2.default.func,
  kw: _propTypes2.default.string
}, _class3.contextTypes = {
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'filter', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'filter'), _class2.prototype)), _class2)) || _class);
exports.default = PlaylistsSearchBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlists/components/PlaylistsSearchBar/PlaylistsSearchBar.js
// module id = 2184
// module chunks = 1